import React from "react"
import { Button } from "@material-ui/core"
import LinkIcon from "@material-ui/icons/Link"
import { useDispatch } from "react-redux"
import { openSnackBar } from "../../../../actions/snack-bar"
import PropTypes from "prop-types"

const CopyLinkButton = ({ uniqueString = "", docType = "", ...props }) => {
  // receives unique string from admin pages to conceal shootId
  const dispatch = useDispatch()

  const baseUrl =
    process.env.REACT_APP_ENV === "production"
      ? "https://crewmama.com"
      : process.env.REACT_APP_ENV === "staging"
        ? "https://staging.adesk.app"
        : "http://localhost:3000"

  function copy() {
    const el = document.createElement("input")
    el.value = `${baseUrl}/${docType}/${uniqueString}`

    document.body.appendChild(el)
    el.select()
    document.execCommand("copy")
    document.body.removeChild(el)
    dispatch(openSnackBar({ message: "Link copied to clipboard" }))
  }
  return (
    <Button
      onClick={copy}
      size="small"
      variant="outlined"
      style={{
        border: "0px solid #EBEBEB",
        borderRadius: "5px",
        backgroundColor: "#EBEBEB",
      }}
      {...props}
    >
      <LinkIcon />
      Copy Link
    </Button>
  )
}

CopyLinkButton.propTypes = {
  uniqueString: PropTypes.string,
  docType: PropTypes.string,
}

export default CopyLinkButton
